module.exports = __webpack_public_path__ + "img/metamask-menu.29ef8a53.png";